import React from "react";
import { Col, Form } from "react-bootstrap";

export interface TextFieldProps {
  label: string;
  value: string | number | null | undefined;
  colSize?: number;
  isEditable?: boolean;
  isDisabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  requiredBadge?: React.ReactNode;
  labelExtra?: React.ReactNode;
  isTextarea?: boolean;
  type?: string;
  min?: number;
  max?: number;
}

export const TextField: React.FC<TextFieldProps> = ({
  label,
  value,
  colSize = 4,
  isEditable = false,
  isDisabled = false,
  onChange,
  required = false,
  requiredBadge,
  labelExtra,
  isTextarea = false,
  type = "text",
  min,
  max,
}) => (
  <Col xs={12} md={colSize}>
    <Form.Group className="mb-3">
      <Form.Label>
        {label}{required && " *"} {requiredBadge} {labelExtra}
      </Form.Label>
      <Form.Control
        type={isTextarea ? undefined : type}
        as={isTextarea ? "textarea" : undefined}
        value={value ?? ""}
        readOnly={!isEditable}
        disabled={!isEditable || isDisabled}
        onChange={isEditable ? onChange : undefined}
        min={min}
        max={max}
      />
    </Form.Group>
  </Col>
);

export default TextField;
